export default __webpack_public_path__ + "static/media/Picture6.0b6f3c70.jpg";